import { difference } from 'lodash';

import { AuditFindingQAStatus } from './audit-finding';

export enum AiSummaryKey {
  DISABILITIES_AFFECTED = 'DISABILITIES_AFFECTED',
  LEAST_ACCESSIBLE_SCREENS = 'LEAST_ACCESSIBLE_SCREENS',
  PRIORITIZE_OPTIMIZING_FOR_RISK = 'PRIORITIZE_OPTIMIZING_FOR_RISK',
  PRIORITIZE_OPTIMIZING_FOR_VPAT = 'PRIORITIZE_OPTIMIZING_FOR_VPAT',
  MONITORING_LAST_SCAN_INSIGHTS = 'MONITORING_LAST_SCAN_INSIGHTS',
  PROGRAM_DASHBOARD_REPORT_REMEDIATED_FINDINGS = 'PROGRAM_DASHBOARD_REPORT_REMEDIATED_FINDINGS',
  PROGRAM_DASHBOARD_REPORT_OPEN_FINDINGS_BY_SEVERITY = 'PROGRAM_DASHBOARD_REPORT_OPEN_FINDINGS_BY_SEVERITY',
}

export enum DataSourceType {
  audit = 'audit',
  scan = 'scan',
  monitoring_scan = 'monitoring_scan',
  organization_metrics = 'organization_metrics',
}

export enum DataSummaryStatus {
  pending = 'pending',
  processing = 'processing',
  done = 'done',
  error = 'error',
}

export const ManualAuditAiSummaryIgnoredIssueStatus: AuditFindingQAStatus[] = [
  AuditFindingQAStatus.dismissed,
  AuditFindingQAStatus.fixed,
  AuditFindingQAStatus.cannotBeFixed,
  AuditFindingQAStatus.notReproducible,
  AuditFindingQAStatus.toReview,
  AuditFindingQAStatus.validationRequested,
  AuditFindingQAStatus.ignored,
];

export const ManualAuditAiSummaryAllowedIssueStatus: AuditFindingQAStatus[] = difference(
  Object.values(AuditFindingQAStatus),
  ManualAuditAiSummaryIgnoredIssueStatus,
);
